/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// Formik and Yup

// Dashboard components
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Functions from store
import {
  createDynamicColumn,
  getDocumentType,
  getDocumentTypeTurnAroundTime,
  getDocumentTypeTurnAroundTimeDownload,
  getDynamicColumn,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import { addMinutes, format } from "date-fns";
const cookies = new Cookies();

const DocumentType = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getDynamicColumn,
  getDocumentType,
  getDocumentTypeReducer,
  getDocumenTypeTurnReducer,
  getDocumentTypeTurnAroundTime,
  getDocumenTypeTurnDownloadReducer,
  getDocumentTypeTurnAroundTimeDownload,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  const [documentTypeSelected, setDocumentTypeSelected] = useState("");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  useEffect(() => {
    getDocumentType(jwtToken);
  }, []);

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    getDocumentTypeTurnAroundTime(
      pageNo,
      rowsPerPage,
      searchObject,
      documentTypeSelected ? documentTypeSelected.value : "",
      jwtToken,
    );
  }, [pageNo, rowsPerPage, searchObject, documentTypeSelected]);

  useEffect(() => {
    getDocumentTypeTurnAroundTimeDownload(
      pageNo,
      rowsPerPage,
      searchObject,
      documentTypeSelected ? documentTypeSelected.value : "",
      jwtToken,
    );
  }, [pageNo, rowsPerPage, searchObject, documentTypeSelected]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let documentTypeTurnAroundModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "dbc03a0c-4160-4b41-9303-6c20f97a3d53",
  );

  let viewAccess = documentTypeTurnAroundModule
    ? documentTypeTurnAroundModule.actionId.includes(
        "6ab9e198-e4a5-48ae-aac0-975bd8d82ee0",
      )
    : null;

  const navigate = useNavigate();

  const statusOptions = [
    {
      label: "All status",
      value: "",
    },
    {
      label: "Open",
      value: 1,
    },
    {
      label: "In-Progress",
      value: 2,
    },
    {
      label: "Closed",
      value: 3,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "Document Type", accessor: "documentName" },
      { Header: "Document Number", accessor: "documentNumber" },
      { Header: "Doc type Turn around time", accessor: "turnAroundTime" },
      {
        Header: "Status",
        accessor: "documentStatus",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      ,
      { Header: "createdDate", accessor: "createdDate" },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getDocumenTypeTurnReducer.types.data
      ? getDocumenTypeTurnReducer.types.data
      : [];
    setLoading(getDocumenTypeTurnReducer.loading);
    setPaginationObj(getDocumenTypeTurnReducer.types?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.documentCd);
      const finishedGoodsObject = {
        picklistCode: finishedGoods.picklistCode,
        documentName: finishedGoods.documentName,
        documentNumber: finishedGoods.documentNumber,
        source: finishedGoods.source,
        destination: finishedGoods.destination,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        turnAroundTime: finishedGoods.turnAroundTime,
        documentStatus: (
          <button
            className={
              (finishedGoods.documentStatus === 1 && `status-success`) ||
              (finishedGoods.documentStatus === 2 && `status-info`) ||
              (finishedGoods.documentStatus === 3 && `status-warning`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.documentStatus === 1 && `Open`) ||
              (finishedGoods.documentStatus === 2 && `In-Progress`) ||
              (finishedGoods.documentStatus === 3 && `Closed`)}
          </button>
        ),
        status2:
          (finishedGoods.documentStatus === 1 && `Open`) ||
          (finishedGoods.documentStatus === 2 && `In-Progress`) ||
          (finishedGoods.documentStatus === 3 && `Closed`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getDocumenTypeTurnReducer]);

  const [Download, setDownload] = useState("");

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getDocumenTypeTurnDownloadReducer.types
      ? getDocumenTypeTurnDownloadReducer.types
      : [];
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.documentCd);
      const finishedGoodsObject = {
        picklistCode: finishedGoods.picklistCode,
        documentType: finishedGoods.documentName,
        documentNumber: finishedGoods.documentNumber,
        source: finishedGoods.source,
        destination: finishedGoods.destination,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        turnAroundTime: finishedGoods.turnAroundTime,
        documentStatus: (
          <button
            className={
              (finishedGoods.documentStatus === 1 && `status-success`) ||
              (finishedGoods.documentStatus === 2 && `status-info`) ||
              (finishedGoods.documentStatus === 3 && `status-warning`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.documentStatus === 1 && `Open`) ||
              (finishedGoods.documentStatus === 2 && `In-Progress`) ||
              (finishedGoods.documentStatus === 3 && `Closed`)}
          </button>
        ),
        status2:
          (finishedGoods.documentStatus === 1 && `Open`) ||
          (finishedGoods.documentStatus === 2 && `In-Progress`) ||
          (finishedGoods.documentStatus === 3 && `Closed`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setDownload(tempFinishedGoods);
  }, [getDocumenTypeTurnDownloadReducer]);

  const headers = [
    {
      label: "documentType",
      key: "documentType",
    },
    { label: "documentNumber", key: "documentNumber" },
    {
      label: "Doc type Turn around time",
      key: "turnAroundTime",
    },
    {
      label: "status",
      key: "status2",
    },
    {
      label: "createdDate",
      key: "createdDate2",
    },
  ];

  const csvLink = {
    filename: "DocumentType.csv",
    headers: headers,
    data: Download,
  };

  const handleDocumentTypeChange = (selectedDocumentType) => {
    setDocumentTypeSelected(selectedDocumentType);
  };

  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getDocumentTypeReducer.documentType.data
      ? getDocumentTypeReducer.documentType.data
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.documentName,
        value: document.documentId,
      });
    });
    setDocumentTypeOptions(tempDocumentTypeOptions);
  }, [getDocumentTypeReducer]);

  const subModuleId = "dbc03a0c-4160-4b41-9303-6c20f97a3d53";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getDocumentTypeTurnAroundTime(documentTypeSelected?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-2}
              >
                <Grid container spacing={2}>
                  <Grid item xs={8} lg={8}>
                    <MDBox
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                    >
                      <MDBox
                        width={{ xs: "150px", lg: "300px" }}
                        style={{
                          marginRight: "10px",
                        }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Document Type
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          autoComplete="off"
                          value={documentTypeSelected}
                          options={documentTypeOptions}
                          onChange={handleDocumentTypeChange}
                        />
                      </MDBox>

                      <MDBox style={{ marginTop: "25px", marginLeft: "8px" }}>
                        <CSVLink {...csvLink}>
                          <DownloadDataButton
                            type="button"
                            variant="outlined"
                            color="success"
                            style={{ borderRadius: "5px" }}
                            size="small"
                            iconOnly
                            tooltip="Download All Data"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getDocumentTypeReducer: state.getDocumentTypeReducer,
    getDocumenTypeTurnReducer: state.getDocumenTypeTurnReducer,
    getDocumenTypeTurnDownloadReducer: state.getDocumenTypeTurnDownloadReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getDocumentTypeTurnAroundTime: (
      pageNo,
      rowsPerPage,
      searchObject,
      documentId,
      jwtToken,
    ) =>
      dispatch(
        getDocumentTypeTurnAroundTime(
          pageNo,
          rowsPerPage,
          searchObject,
          documentId,
          jwtToken,
        ),
      ),
    getDocumentTypeTurnAroundTimeDownload: (
      pageNo,
      rowsPerPage,
      searchObject,
      documentId,
      jwtToken,
    ) =>
      dispatch(
        getDocumentTypeTurnAroundTimeDownload(
          pageNo,
          rowsPerPage,
          searchObject,
          documentId,
          jwtToken,
        ),
      ),
    getDocumentType: (jwtToken) => dispatch(getDocumentType(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(DocumentType);
